module.exports = __webpack_public_path__ + "source/img/speeching.27c9d2b5.svg";